import React, { useState } from "react";
import AnnouncementCompose from "./AnnouncementCompose";
import SentAnnouncements from "./SentAnnouncements";
import AnnouncementTemplates from "./AnnouncementTemplates";
import AnnouncementSchedules from "./AnnouncementSchedules";

const SwitchClassAnnouncements = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return <AnnouncementCompose />;
      case 2:
        return <SentAnnouncements />;
      case 3:
        return <AnnouncementTemplates />;
      case 4:
        return <AnnouncementSchedules />;
      default:
        return <AnnouncementCompose />;
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-4 bg-white rounded-lg">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${step === 1 ? "bg-gray-600 text-white shadow" : ""}`}
          >
            <div className="text-lg">Post Announcement</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${step === 2 ? "bg-gray-600 text-white shadow" : ""}`}
          >
            <div className="text-lg">Sent Announcements</div>
          </div>
          <div
            onClick={() => setStep(3)}
            className={`iskool-tab-item ${step === 3 ? "bg-gray-600 text-white shadow" : ""}`}
          >
            <div className="text-lg">Templates</div>
          </div>
          <div
            onClick={() => setStep(4)}
            className={`iskool-tab-item ${step === 4 ? "bg-gray-600 text-white shadow" : ""}`}
          >
            <div className="text-lg">Schedules</div>
          </div>
        </div>
        <div>{switchTab()}</div>
      </div>
    </>
  );
};

export default SwitchClassAnnouncements;
